<script>
import moment from 'moment'
import appConfig from '@src/app.config'
import { crudMethods } from '@state/helpers'

export default {
  page: {
    title: 'Dashboard',
    meta: [{ name: 'description', content: appConfig.description }],
  },

  components: {},

  data() {
    return {
      user: this.$store ? this.$store.state.auth.currentUser : {} || {},

      dataPie: {
        chartOptions: {
          chart: {
            type: 'donut',
            toolbar: {
              show: false,
            },
            fontFamily: 'inherit',
          },

          colors: ['#f59e0b', '#2563eb'],

          stroke: {
            width: 2,
            colors: ['#ffffff'],
          },

          labels: [],

          dataLabels: {
            enabled: true,
            style: {
              fontSize: '11px',
              fontWeight: 600,
            },
            dropShadow: {
              enabled: false,
            },
          },

          plotOptions: {
            pie: {
              expandOnClick: true,
              customScale: 0.92,
              donut: {
                size: '62%',
                labels: {
                  show: true,
                  name: {
                    show: true,
                    fontSize: '11px',
                    color: '#64748b',
                  },
                  value: {
                    show: true,
                    fontSize: '15px',
                    fontWeight: 700,
                    color: '#1e293b',
                  },
                  total: {
                    show: true,
                    label: 'Total',
                    fontSize: '11px',
                    color: '#94a3b8',
                    fontWeight: 600,
                  },
                },
              },
            },
          },

          legend: {
            show: true,
            position: 'bottom',
            horizontalAlign: 'center',
            fontSize: '11px',
            labels: {
              colors: '#64748b',
            },
            markers: {
              width: 8,
              height: 8,
              radius: 8,
            },
            itemMargin: {
              horizontal: 8,
              vertical: 4,
            },
          },

          tooltip: {
            y: {
              formatter: (value) => {
                return this.formatCompactCurrency(value)
              },
            },
          },

          responsive: [
            {
              breakpoint: 768,
              options: {
                chart: {
                  height: 300,
                },
                legend: {
                  position: 'bottom',
                  horizontalAlign: 'center',
                },
              },
            },
          ],
        },

        series: [],
      },

      year: moment().format('YYYY'),
      years: [],
    }
  },

  mounted() {
    this.getData()

    for (let i = this.year; i >= 2022; i--) {
      this.years.push(i)
    }
  },

  methods: {
    ...crudMethods,

    getData() {
      this.listData({
        url: `web/dashboard/pie-panjar?year=${this.year}`,
      }).then((response) => {
        const data = response.data.data || {}

        this.setPieChartData(data)
      })
    },

    setPieChartData(data) {
      this.dataPie = {
        series: data.series || [],

        chartOptions: {
          ...this.dataPie.chartOptions,
          labels: data.labels || [],
        },
      }
    },

    changeYear() {
      this.getData()
    },

    formatCompactCurrency(value) {
      const number = Math.abs(Number(value))

      if (number >= 1.0e9) {
        return `Rp${(number / 1.0e9).toFixed(2)} M`
      }

      if (number >= 1.0e6) {
        return `Rp${(number / 1.0e6).toFixed(2)} Jt`
      }

      if (number >= 1.0e3) {
        return `Rp${(number / 1.0e3).toFixed(2)} Rb`
      }

      return `Rp${number.toLocaleString('id-ID')}`
    },
  },
}
</script>

<template>
  <div class="col-xl-6 dashboard-widget">
    <div class="card dashboard-card">
      <!-- Header -->
      <div class="card-header dashboard-card-header">
        <div class="header-title-wrapper">
          <div class="header-icon header-icon-orange">
            <feather type="pie-chart" size="17" />
          </div>

          <div>
            <h5 class="header-title">
              Grafik Plan Panjar
            </h5>

            <div class="header-subtitle">
              Distribusi plan panjar berdasarkan tahun
            </div>
          </div>
        </div>

        <div class="header-action">
          <label for="panjar-year">
            Tahun
          </label>

          <b-form-select
            id="panjar-year"
            v-model="year"
            :options="years"
            size="sm"
            @change="changeYear"
          />
        </div>
      </div>

      <!-- Body -->
      <div class="card-body dashboard-card-body">
        <div v-if="dataPie.series.length > 0" class="chart-wrapper">
          <apexchart
            height="320"
            :series="dataPie.series"
            :options="dataPie.chartOptions"
          />
        </div>

        <div v-else class="empty-chart">
          <feather type="pie-chart" size="28" />

          <span>Tidak ada data</span>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.dashboard-widget {
  margin-bottom: 20px;
}

.dashboard-card {
  height: 100%;
  margin-bottom: 0;
  overflow: hidden;
  border: 1px solid #edf0f3;
  border-radius: 12px;
  background: #ffffff;
  box-shadow: 0 2px 6px rgba(15, 23, 42, 0.03),
    0 8px 24px rgba(15, 23, 42, 0.04);
}

.dashboard-card-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  min-height: 64px;
  padding: 13px 18px;
  border-bottom: 1px solid #f1f5f9;
  background: #ffffff;
}

.header-title-wrapper {
  display: flex;
  align-items: center;
  min-width: 0;
}

.header-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 34px;
  height: 34px;
  margin-right: 11px;
  border-radius: 9px;
}

.header-icon-orange {
  color: #d97706;
  background: #fffbeb;
}

.header-title {
  margin: 0;
  color: #1e293b;
  font-size: 14px;
  font-weight: 700;
  line-height: 1.3;
}

.header-subtitle {
  margin-top: 2px;
  color: #94a3b8;
  font-size: 10px;
  line-height: 1.3;
}

.header-action {
  display: flex;
  align-items: center;
  gap: 7px;
  flex-shrink: 0;

  label {
    margin: 0;
    color: #64748b;
    font-size: 11px;
    font-weight: 600;
  }

  .custom-select {
    width: 90px;
    min-height: 32px;
    padding-top: 4px;
    padding-bottom: 4px;
    border-color: #e2e8f0;
    border-radius: 7px;
    color: #475569;
    font-size: 11px;
    box-shadow: none;

    &:focus {
      border-color: #d97706;
      box-shadow: 0 0 0 2px rgba(217, 119, 6, 0.08);
    }
  }
}

.dashboard-card-body {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 350px;
  padding: 12px 18px 16px;
}

.chart-wrapper {
  width: 100%;
}

.empty-chart {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 300px;
  color: #cbd5e1;
  font-size: 11px;

  svg {
    margin-bottom: 8px;
  }
}

@media (max-width: 575.98px) {
  .dashboard-card-header {
    align-items: flex-start;
    flex-direction: column;
    gap: 10px;
  }

  .header-action {
    width: 100%;
    justify-content: flex-end;
  }

  .dashboard-card-body {
    min-height: 320px;
    padding: 10px 12px 14px;
  }
}
</style>
